import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type XCircleIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const XCircleIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: XCircleIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='X circle'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='12'
        cy='12'
        r='10'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='m15 9-6 6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='m9 9 6 6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
